﻿import {GameCategory, GameScreen, MoneyType} from "../../enums";
import {UISprite} from "../Tools/Base/UISprite";
import {UIButton} from "../Tools/Base/UIButton";
import {UIText} from "../Tools/Base/UIText";
import {UINineSlice} from "../Tools/Base/UINineSlice";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {Core} from "../../Base/Core";
import {GameManager} from "../../Game/GameManager";
import {UILabeledIcon} from "../Tools/Base/UILabeledIcon";

class EpochProgressItem extends UISprite {
    Awake() {
        this.marker = this.addChild(new UINineSlice("bg-bar"));
        this.icon = this.addChild(new UISprite(""));
    }

    Init(creatureId, progressPosition) {
        let epoch = Core.GameData.Epochs.GetByCreatureId(creatureId);
        let creature = Core.GameData.Creatures.Get(creatureId);

        this.icon.setImage("creatures/" + creature.id);

        let idx = epoch.creatures.indexOf(creatureId);
        if (idx > progressPosition) {
            // Not opened
            this.icon.tint = 0x000000;
            this.marker.tint = 0x000000;
            this.marker.alpha = 0.5;
        } else {
            this.icon.tint = 0xffffff;
            this.marker.tint = 0x00ff00;
            this.marker.alpha = idx === progressPosition ? 1 : 0.3;
        }
    }

    fitLayout(rect) {
        this.position.set(rect.x, rect.y);

        let tmpRect = rect.clone();
        tmpRect.height = rect.height * 0.2;
        tmpRect.width = rect.width * 0.95;
        tmpRect.y = 0;
        tmpRect.x = (rect.width - tmpRect.width) * 0.5;
        this.marker.fitLayout(tmpRect);

        tmpRect = rect.clone();
        tmpRect.height = rect.height * 0.78;
        tmpRect.width = rect.width * 0.9;
        tmpRect.y = (rect.height - tmpRect.height) * 1;
        tmpRect.x = (rect.width - tmpRect.width) * 0.5;

        this.icon.position.set(tmpRect.x + tmpRect.width * 0.5, tmpRect.y + tmpRect.height * 0.5);
        this.icon.scale.set(Math.min((tmpRect.width * 1) / this.icon.texture.width, (tmpRect.height * 1) / this.icon.texture.height));
    }
}

class EpochProgress extends UISprite {
    Awake() {
        this.markers = [];
    }

    Init(creatureId) {
        let epochData = Core.GameData.Epochs.GetByCreatureId(creatureId);
        let indexOfNewCreature = epochData.creatures.indexOf(creatureId);

        // Add markers if needed
        while (this.markers.length < epochData.creatures.length) {
            let marker = this.addChild(new EpochProgressItem());
            this.markers.push(marker);
        }
        // Remove redundant markers
        while (this.markers.length > epochData.creatures.length) {
            let marker = this.markers.pop();
            if (marker.parent) marker.parent.removeChild(parent);
        }

        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].Init(epochData.creatures[i], indexOfNewCreature);
        }
    }

    fitLayout(rect) {
        this.position.set(rect.x, rect.y);

        let markerRect = rect.clone();
        markerRect.x = 0;
        markerRect.y = 0;
        markerRect.width = rect.width / (this.markers.length || 1);

        for (let marker of this.markers) {
            marker.fitLayout(markerRect);
            markerRect.x += markerRect.width;
        }
    }
}

export class UINewCreature extends UICommonPopup {

    get diamondGlobalParams() {
        let {
            a: scale,
            tx: x,
            ty: y
        } = this.ribbonLabel._icon.transform.worldTransform;
        return {
            scale: scale * Core.app.renderer.resolution,
            x: x * Core.app.renderer.resolution,
            y: y * Core.app.renderer.resolution,
        };
    }

    Awake() {
        super.Awake();

        this.creatureShadow = this.content.addChild(new UISprite("shadow"));
        this.creatureShadow.alpha = 0.5;
        this.creatureIcon = this.content.addChild(new UISprite());
        this.ribbon = this.content.addChild(new UISprite("ribbon"));
        this.ribbonLabel = this.content.addChild(new UILabeledIcon({
            label: "+1",
            icon: "ico-diamond",
            iconAlign: "right",
        }));

        this.title = this.content.addChild(
            new UIText(Core.Localizator.Get("new_monster_title"), {
                fontSize: 64,
                wordWrap: true,
                wordWrapWidth: 500,
                align: "center",
            })
        );

        this.creatureName = this.content.addChild(new UIText("", { fontSize: 40 }));

        this.epochProgress = this.content.addChild(new EpochProgress());

        this.hardMoneyObject = this.content.addChild(new UISprite()); // Transform hardMoneyObject;

        this.okBtn = this.content.addChild(
            new UINineSliceButton("btn-green", {
                label: Core.Localizator.Get("ok"),
                textProps: { fontSize: 64, autoFitPadding: 8 },
            })
        );

        this.shareBtn = this.content.addChild(new UIButton()); // Button shareBtn;

        this.newEpochId = 0;
        this.creatureId = 0;
    }

    fitLayout(viewport = Core.app.viewport) {
        super.fitLayout(viewport);

        let sideRatio = 1.6;
        let w = Math.min(viewport.width * 0.85, (viewport.height * 0.85) / sideRatio);
        let h = w * sideRatio;

        this.setPopupRect(new PIXI.Rectangle((viewport.width - w) * 0.5, (viewport.height - h) * 0.62, w, h));

        let popupRect = this.getContentSize();

        let rect = popupRect.clone();
        rect.height = popupRect.height * 0.15;
        rect.width = popupRect.width * 0.8;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.01;
        this.title.wordWrapWidth = popupRect.width * 0.8;
        this.title.fitLayout(rect);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.47;
        rect.width = popupRect.width * 0.7;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.28;
        this.creatureIcon.fitRect(rect);

        rect.y = rect.bottom - rect.height * 0.6;
        rect.x = 0;
        rect.width = popupRect.width;
        this.creatureShadow.fitRect(rect);

        rect = popupRect.clone();
        rect.width = popupRect.width * 0.25;
        rect.x = popupRect.right - rect.width * 0.9;
        rect.height = rect.width * 0.77;
        rect.y = (popupRect.height - rect.height) * 0.5;
        this.ribbon.fitRect(rect);

        rect.height *= 0.9;
        rect.x += rect.width * 0.25;
        rect.width *= 0.6;
        this.ribbonLabel.fitLayout(rect);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.07;
        rect.width = popupRect.width * 0.45;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.68;
        this.creatureName.fitLayout(rect);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.12;
        rect.width = popupRect.width * 0.9;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.81;
        this.epochProgress.fitLayout(rect);

        rect = popupRect.clone();
        rect.width = popupRect.width * 0.45;
        rect.height = popupRect.height * 0.12;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.97;
        this.okBtn.fitLayout(rect);
    }

    SetNewEpochId(epochId) {
        this.newEpochId = epochId;
    }

    Init() {
        super.Init();

        this.okBtn.interactive = true;
        this.okBtn.cursor = "pointer";
        this.okBtn.on("pointertap", () => this.Hide());

        Core.Player.PlanetsSave.on("EpochUnlocked", epoch => this.newEpochId = epoch);

        this.shareBtn.SetActive(false);
    }

    Show(newCreatureId = null) {
        if (newCreatureId !== null) {
            this.creatureId = newCreatureId;
            this.updateUI(newCreatureId);
            Core.Audio.Play("NewCreature");
        }
        super.Show();
        this.shareBtn.interactive = true;
    }

    Hide() {
        if (Core.UI) {
            Core.VFX.newCreatureDiamond(this.diamondGlobalParams);
            Core.WaitBefore(1, () => {
                Core.Player.AddMoney(MoneyType.Hard, 1, GameCategory.empty, GameScreen.game, "new_creature_" + this.creatureId);
            });
        }

        if (this.newEpochId != 0) {
            Core.WaitBefore(0.25, () => {
                GameManager.gameView.SelectEpoch(this.newEpochId, true, 0);
                Core.UI.newEpoch.Show(this.newEpochId);
                this.newEpochId = 0;
            });
        }

        if (Core.Player.PlanetsSave.collection.length === Core.GameData.Slots.availableFromCollectionSize) {
            GameManager.tutorialState = 2000; // Spins button tutorial
        }

        super.Hide();
    }

    updateUI(creatureId) {
        let newCreatureData = Core.GameData.Creatures.Get(creatureId);
        this.creatureIcon.setImage("creatures/" + creatureId);
        this.creatureName.text = Core.Localizator.Get(newCreatureData.creatureName);
        this.epochProgress.SetActive(!newCreatureData.IsFinalForm);
        if (this.epochProgress.Active) {
            this.epochProgress.Init(creatureId);
        }
        this.fitLayout();
    }
}
